var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPokeballBgSvgomg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 377,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.381 188.5c0 24.787-20.094 44.881-44.881 44.881s-44.881-20.094-44.881-44.881 20.094-44.881 44.881-44.881 44.881 20.094 44.881 44.881Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.5 377c94.963 0 173.525-70.222 186.591-161.571H263.689c-11.09 31.377-41.014 53.857-76.189 53.857-35.175 0-65.099-22.48-76.189-53.857H.909C13.975 306.778 92.537 377 187.5 377Zm-76.189-215.429H.909C13.975 70.221 92.537 0 187.5 0c94.963 0 173.525 70.222 186.591 161.571H263.689c-11.09-31.377-41.014-53.857-76.189-53.857-35.175 0-65.099 22.48-76.189 53.857Zm121.07 26.929c0 24.787-20.094 44.881-44.881 44.881s-44.881-20.094-44.881-44.881 20.094-44.881 44.881-44.881 44.881 20.094 44.881 44.881Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeballBgSvgomg);
export default __webpack_public_path__ + "static/media/pokeball-bg-svgomg.e5ca68bc0da863870042d0daabc214dc.svg";
export { ForwardRef as ReactComponent };